<section class="scheda-wrap px-container pb-16">

    <div class="scheda-title-strip">
        <h2>{{ evento?.evento || 'Area Compagnia' }}</h2>
        <span class="meta">
            {{ evento?.dal | date: 'dd MMMM yyyy' }}
            @if (evento?.al && evento?.dal !== evento?.al) {
                — {{ evento?.al | date: 'dd MMMM yyyy' }}
            }
            · {{ evento?.ragione_sociale }}
        </span>
    </div>

    <form [formGroup]="formEvento" (ngSubmit)="onSubmit()">

        <!-- §1 EVENTO E COMPAGNIA -->
        <section class="sec dossier" [class.collapsed]="!openSections['dossier']">
            <div class="sec-head" (click)="toggleSec('dossier')">
                <h3>Evento e Compagnia</h3>
                <span class="stato-mini" [ngClass]="(evento?.visura_camerale && evento?.duvri) ? 'ok' : 'crit'">
                    {{ (evento?.visura_camerale && evento?.duvri) ? 'documenti ok' : 'documenti incompleti' }}
                </span>
                <span class="toggle">▾</span>
            </div>
            <div class="sec-body">
                <div class="fld-grid three">
                    <div class="fld">
                        <label>* Spettacolo / Evento</label>
                        <input type="text" pInputText formControlName="evento" required />
                        @if (formEvento.get('evento')?.hasError('required') && (formEvento.get('evento')?.dirty || formEvento.get('evento')?.touched)) {
                            <small class="text-red-600 block font-medium">Lo Spettacolo / Evento è obbligatorio!</small>
                        }
                    </div>
                    <div class="fld">
                        <label>* Data inizio - Data fine</label>
                        <p-calendar placeholder="dd/mm/aaaa - dd/mm/aaaa" formControlName="dal_al" [showIcon]="true" selectionMode="range" appendTo="body"></p-calendar>
                        @if (formEvento.get('dal_al')?.hasError('required') && (formEvento.get('dal_al')?.dirty || formEvento.get('dal_al')?.touched)) {
                            <small class="text-red-600 block font-medium">La Data di Inizio e Fine sono obbligatorie!</small>
                        }
                    </div>
                    <div class="fld">
                        <label>* Ragione Sociale</label>
                        <input type="text" pInputText formControlName="ragione_sociale" required />
                        @if (formEvento.get('ragione_sociale')?.hasError('required') && (formEvento.get('ragione_sociale')?.dirty || formEvento.get('ragione_sociale')?.touched)) {
                            <small class="text-red-600 block font-medium">La Ragione Sociale è obbligatoria!</small>
                        }
                    </div>
                </div>

                <div class="fld-grid">
                    <div class="fld">
                        <label>* Partita IVA / Codice Fiscale</label>
                        <input type="text" pInputText formControlName="piva" required />
                        @if (formEvento.get('piva')?.hasError('required') && (formEvento.get('piva')?.dirty || formEvento.get('piva')?.touched)) {
                            <small class="text-red-600 block font-medium">La P.Iva / Cod. Fiscale sono obbligatori!</small>
                        }
                    </div>
                    <div class="fld">
                        <label>* Sede Legale</label>
                        <input type="text" pInputText formControlName="sede" required />
                        @if (formEvento.get('sede')?.hasError('required') && (formEvento.get('sede')?.dirty || formEvento.get('sede')?.touched)) {
                            <small class="text-red-600 block font-medium">La Sede Legale è obbligatoria!</small>
                        }
                    </div>
                </div>

                <span class="sec-subtitle">Referente</span>
                <div class="fld-grid three">
                    <div class="fld">
                        <label>* Cognome e Nome</label>
                        <input type="text" pInputText formControlName="anagrafica" required />
                        @if (formEvento.get('anagrafica')?.hasError('required') && (formEvento.get('anagrafica')?.dirty || formEvento.get('anagrafica')?.touched)) {
                            <small class="text-red-600 block font-medium">Il Cognome e Nome è obbligatorio!</small>
                        }
                    </div>
                    <div class="fld">
                        <label>* Email</label>
                        <input type="email" pInputText formControlName="email" required />
                        @if (formEvento.get('email')?.hasError('required') && (formEvento.get('email')?.dirty || formEvento.get('email')?.touched)) {
                            <small class="text-red-600 block font-medium">L'Email è obbligatoria!</small>
                        }
                        @if (formEvento.get('email')?.hasError('email') && (formEvento.get('email')?.dirty || formEvento.get('email')?.touched)) {
                            <small class="text-red-600 block font-medium">Inserire un'Email valida!</small>
                        }
                    </div>
                    <div class="fld">
                        <label>* Telefono</label>
                        <input type="tel" pInputText formControlName="telefono" required />
                        @if (formEvento.get('telefono')?.hasError('required') && (formEvento.get('telefono')?.dirty || formEvento.get('telefono')?.touched)) {
                            <small class="text-red-600 block font-medium">Il Numero di Telefono è obbligatorio!</small>
                        }
                        @if (formEvento.get('telefono')?.hasError('pattern') && (formEvento.get('telefono')?.dirty || formEvento.get('telefono')?.touched)) {
                            <small class="text-red-600 block font-medium">Inserire un Numero di Telefono valido!</small>
                        }
                    </div>
                </div>

                <span class="sec-subtitle">Documenti compagnia</span>
                <div class="doc-list">
                    @if ((evento?.visura_camerale || '').length > 0) {
                        <app-file-loaded [evento]="evento" [tipo]="'visura_camerale'" [file]="evento?.visura_camerale || ''" [title]="'Visura camerale'" [meta]="'caricata · clicca Apri per scaricare'" [status]="'caricato'" [tooltip]="'Rimuovi la visura camerale caricata'"></app-file-loaded>
                        <div class="visura-scadenza-row">
                            <label for="visura_scadenza">Scadenza visura</label>
                            <input
                                id="visura_scadenza"
                                type="date"
                                class="scadenza-input"
                                [value]="visuraScadenzaValue"
                                (change)="onVisuraScadenza($event)"
                                [class.scaduto]="isVisuraScaduta" />
                        </div>
                    } @else {
                        <div class="doc-missing crit">
                            <div class="doc-missing-info">                                
                                <div class="doc-info">
                                    <strong>Visura camerale</strong>
                                    <span class="doc-meta crit">non caricato · obbligatorio</span>
                                </div>
                            </div>
                            <app-file-upload [form]="formEvento" [control]="'visura_camerale'" [label]="''" [multiple]="false" [critical]="true" [accept]="'.doc,.docx,application/pdf,image/*'" [text]="'Trascina qui il file'"></app-file-upload>
                        </div>
                    }

                    @if ((evento?.duvri || '').length > 0) {
                        <app-file-loaded [evento]="evento" [tipo]="'duvri'" [file]="evento?.duvri || ''" [title]="'DVR / DUVRI'" [meta]="'caricato · clicca Apri per scaricare'" [status]="'caricato'" [tooltip]="'Rimuovi il dvr e/o duvri caricato'"></app-file-loaded>
                    } @else {
                        <div class="doc-missing crit">
                            <div class="doc-missing-info">
                                <div class="doc-info">
                                    <strong>DVR / DUVRI</strong>
                                    <span class="doc-meta crit">non caricato · obbligatorio</span>
                                </div>
                            </div>
                            <app-file-upload [form]="formEvento" [control]="'duvri_file'" [label]="''" [multiple]="false" [critical]="true" [accept]="'.doc,.docx,application/pdf,image/*'" [text]="'Trascina qui il file'"></app-file-upload>
                        </div>
                    }

                    @for (scheda_tecnica of schede_tecniche; track scheda_tecnica.id) {
                        <app-file-loaded [evento]="evento" [documento]="scheda_tecnica" [tipo]="'scheda_tecnica'" [file]="scheda_tecnica.file || ''" [title]="'Scheda tecnica / Piano di produzione'" [meta]="'caricato · clicca Apri per scaricare'" [status]="'caricato'" [tooltip]="'Rimuovi la scheda tecnica'"></app-file-loaded>
                    }
                    <div class="doc-missing" [class.crit]="schede_tecniche.length <= 0">
                        <div class="doc-missing-info">
                            <div class="doc-info">
                                <strong>Scheda tecnica / Piano di produzione</strong>
                                <span class="doc-meta" [class.crit]="schede_tecniche.length <= 0">{{ schede_tecniche.length <= 0 ? 'non caricato' : 'aggiungi altri file' }}</span>
                            </div>
                        </div>
                        <app-file-upload [form]="formEvento" [control]="'scheda_tecnica'" [label]="''" [multiple]="true" [critical]="schede_tecniche.length <= 0" [accept]="'.doc,.docx,application/pdf,image/*'" [text]="'Trascina qui il file'"></app-file-upload>
                    </div>
                </div>
            </div>
        </section>

        <!-- §2 INFORMAZIONI -->
        <section class="sec info" [class.collapsed]="!openSections['info']">
            <div class="sec-head" (click)="toggleSec('info')">
                <h3>Informazioni aggiuntive</h3>
                <span class="stato-mini ok">parametri evento</span>
                <span class="toggle">▾</span>
            </div>
            <div class="sec-body block-stack">
                <div class="flag-row">
                    <p-checkbox inputId="obbligatorieta" name="obbligatorieta" formControlName="obbligatorieta" value="Obbligatorieta" />
                    <label for="obbligatorieta">Documenti Compagnia e Subappalto obbligatori</label>
                </div>

                <div class="fld-grid three">
                    <div class="fld">
                        <label>* Blocco caricamento (ore)</label>
                        <input type="number" pInputNumber formControlName="blocco" required />
                        @if (formEvento.get('blocco')?.hasError('required') && (formEvento.get('blocco')?.dirty || formEvento.get('blocco')?.touched)) {
                            <small class="text-red-600 block font-medium">Il Blocco di caricamento è obbligatoria!</small>
                        }
                    </div>
                    <div class="fld">
                        <label>* Durata spettacolo (minuti)</label>
                        <p-inputNumber formControlName="durata" />
                        @if (formEvento.get('durata')?.hasError('required') && (formEvento.get('durata')?.dirty || formEvento.get('durata')?.touched)) {
                            <small class="text-red-600 block font-medium">La Durata è obbligatoria!</small>
                        }
                    </div>
                    <div class="fld">
                        <label>* Intervallo</label>
                        <div class="choice-group">
                            <div class="choice">
                                <p-radioButton name="intervallo" value="Si" inputId="intervallo_si" formControlName="intervallo" />
                                <label for="intervallo_si">Si</label>
                            </div>
                            <div class="choice">
                                <p-radioButton name="intervallo" value="No" inputId="intervallo_no" formControlName="intervallo" />
                                <label for="intervallo_no">No</label>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="fld">
                    <label>* Attività previste</label>
                    <div class="choice-group">
                        <div class="choice">
                            <p-checkbox inputId="attivita1" name="attivita" formControlName="attivita" value="Montaggio" />
                            <label for="attivita1">Montaggio</label>
                        </div>
                        <div class="choice">
                            <p-checkbox inputId="attivita2" name="attivita" formControlName="attivita" value="Prove" />
                            <label for="attivita2">Prove</label>
                        </div>
                        <div class="choice">
                            <p-checkbox inputId="attivita3" name="attivita" formControlName="attivita" value="Spettacolo" />
                            <label for="attivita3">Spettacolo</label>
                        </div>
                        <div class="choice">
                            <p-checkbox inputId="attivita4" name="attivita" formControlName="attivita" value="Smontaggio" />
                            <label for="attivita4">Smontaggio</label>
                        </div>
                    </div>
                    @if (formEvento.get('attivita')?.hasError('required') && (formEvento.get('attivita')?.dirty || formEvento.get('attivita')?.touched)) {
                        <small class="text-red-600 block font-medium">L'Attività prevista è obbligatoria!</small>
                    }
                </div>                

                <div class="fld-grid three">
                    <div class="fld">
                        <label>* Il pubblico può fare foto e/o video?</label>
                        <div class="choice-group">
                            <div class="choice">
                                <p-radioButton name="foto" value="Si" inputId="foto_si" formControlName="foto" />
                                <label for="foto_si">Si</label>
                            </div>
                            <div class="choice">
                                <p-radioButton name="foto" value="No" inputId="foto_no" formControlName="foto" />
                                <label for="foto_no">No</label>
                            </div>
                        </div>
                    </div>
                    <div class="fld">
                        <label>* Merchandising</label>
                        <div class="choice-group">
                            <div class="choice">
                                <p-radioButton name="merchandising" value="Si" inputId="merchandising_si" formControlName="merchandising" (onClick)="onMerchandising($event)" />
                                <label for="merchandising_si">Si</label>
                            </div>
                            <div class="choice">
                                <p-radioButton name="merchandising" value="No" inputId="merchandising_no" formControlName="merchandising" (onClick)="onMerchandising($event)" />
                                <label for="merchandising_no">No</label>
                            </div>
                        </div>
                        @if(formEvento.get('merchandising')?.value == 'Si') {
                            <div class="fld mt-3">
                                <label>* Email Referente Merchandising</label>
                                <input type="email" pInputText formControlName="merchandising_email" />
                                @if (formEvento.get('merchandising_email')?.hasError('required') && (formEvento.get('merchandising_email')?.dirty || formEvento.get('merchandising_email')?.touched)) {
                                    <small class="text-red-600 block font-medium">L'Email del Referente è obbligatoria!</small>
                                }
                                @if (formEvento.get('merchandising_email')?.hasError('email') && (formEvento.get('merchandising_email')?.dirty || formEvento.get('merchandising_email')?.touched)) {
                                    <small class="text-red-600 block font-medium">Inserire un'Email valida!</small>
                                }
                            </div>
                        }
                    </div>
                    <div class="fld">
                        <label>* Firmacopie / meet &amp; greet</label>
                        <div class="choice-group">
                            <div class="choice">
                                <p-radioButton name="firmacopie" value="Si" inputId="firmacopie_si" formControlName="firmacopie" (onClick)="onFirmacopie($event)" />
                                <label for="firmacopie_si">Si</label>
                            </div>
                            <div class="choice">
                                <p-radioButton name="firmacopie" value="No" inputId="firmacopie_no" formControlName="firmacopie" (onClick)="onFirmacopie($event)" />
                                <label for="firmacopie_no">No</label>
                            </div>
                        </div>
                        @if(formEvento.get('firmacopie')?.value == 'Si') {
                            <div class="fld mt-3">
                                <label>* Email Referente Firmacopie</label>
                                <input type="email" pInputText formControlName="firmacopie_email" />
                                @if (formEvento.get('firmacopie_email')?.hasError('required') && (formEvento.get('firmacopie_email')?.dirty || formEvento.get('firmacopie_email')?.touched)) {
                                    <small class="text-red-600 block font-medium">L'Email del Referente è obbligatoria!</small>
                                }
                                @if (formEvento.get('firmacopie_email')?.hasError('email') && (formEvento.get('firmacopie_email')?.dirty || formEvento.get('firmacopie_email')?.touched)) {
                                    <small class="text-red-600 block font-medium">Inserire un'Email valida!</small>
                                }
                            </div>
                        }
                    </div>
                </div>
            </div>
        </section>

        <!-- §3 PERSONALE -->
        <section class="sec personale" [class.collapsed]="!openSections['personale']">
            <div class="sec-head" (click)="toggleSec('personale')">
                <h3>Personale</h3>
                <span class="stato-mini" [ngClass]="(evento?.personale || []).length ? 'ok' : 'warn'">
                    {{ (evento?.personale || []).length }} {{(evento?.personale || []).length > 1 ? 'lavoratori' : 'lavoratore'}}
                </span>
                <span class="toggle">▾</span>
            </div>
            <div class="sec-body block-stack">
                <app-personale-accrediti-backoffice [personale]="evento?.personale || []" [evento]="evento" />

                <div class="fld">
                    <label>* Tutti i lavoratori sono muniti di pass identificativo?</label>
                    <div class="choice-group">
                        <div class="choice">
                            <p-radioButton inputId="pass_compagnia_si" value="Si" formControlName="pass_compagnia" (ngModelChange)="onPassCompagnia($event)" />
                            <label for="pass_compagnia_si">Si</label>
                        </div>
                        <div class="choice">
                            <p-radioButton inputId="pass_compagnia_no" value="No" formControlName="pass_compagnia" (ngModelChange)="onPassCompagnia($event)" />
                            <label for="pass_compagnia_no">No</label>
                        </div>
                    </div>
                </div>

                @if(formEvento.get('pass_compagnia')?.value == 'Si') {
                    <div class="doc-list">
                        @if ((evento?.pass || '').length > 0) {
                            <app-file-loaded [evento]="evento" [tipo]="'pass_compagnia'" [file]="evento?.pass || ''" [title]="'Facs simile pass compagnia'" [meta]="'caricato · clicca Apri per scaricare'" [status]="'caricato'" [tooltip]="'Rimuovi il Facs Simile del Pass compagnia'"></app-file-loaded>
                        } @else {
                            <div class="doc-missing crit">
                                <div class="doc-missing-info">
                                    <div class="doc-info">
                                        <strong>Facs simile pass compagnia</strong>
                                        <span class="doc-meta crit">non caricato · obbligatorio</span>
                                    </div>
                                </div>
                                <app-file-upload #uploadPass [form]="formEvento" [control]="'pass_compagnia_file'" [label]="''" [multiple]="false" [critical]="true" [accept]="'.doc,.docx,application/pdf,image/*'" [text]="'Trascina qui il file'"></app-file-upload>
                            </div>
                        }
                    </div>
                }
            </div>
        </section>

        <!-- §4 SUBAPPALTI -->
        <section class="sec subappalti" [class.collapsed]="!openSections['subappalti']">
            <div class="sec-head" (click)="toggleSec('subappalti')">
                <h3>Subappalti</h3>
                <span class="stato-mini" [ngClass]="(evento?.subappalti || []).length ? 'wait' : 'ok'">
                    {{ (evento?.subappalti || []).length + ((evento?.subappalti || []).length > 1 ? ' subappalti' : ' subappalto') || 'nessuno' }}
                </span>
                <span class="toggle">▾</span>
            </div>
            <div class="sec-body">
                <app-subappalti-accrediti-backoffice [subappalti]="evento?.subappalti || []" [evento]="evento" />
            </div>
        </section>

        <!-- §5 AGIBILITÀ E CERTIFICAZIONI -->
        <section class="sec impianti" [class.collapsed]="!openSections['impianti']">
            <div class="sec-head" (click)="toggleSec('impianti')">
                <h3>Agibilità e Certificazioni</h3>
                <span class="stato-mini wait">impianti / INPS</span>
                <span class="toggle">▾</span>
            </div>
            <div class="sec-body block-stack">
                <span class="sec-subtitle" style="border-top:0;padding-top:0;margin-top:0">Agibilità INPS</span>
                <div class="doc-list">
                    @for (agibilita of agibilita_inps; track agibilita.id) {
                        <app-file-loaded [evento]="evento" [documento]="agibilita" [tipo]="'inps'" [file]="agibilita.file || ''" [title]="'Certificato di agibilità INPS'" [meta]="'caricato · clicca Apri per scaricare'" [status]="'caricato'" [tooltip]="'Rimuovi agibilità INPS'"></app-file-loaded>
                    }
                    <div class="doc-missing" [class.crit]="agibilita_inps.length <= 0">
                        <div class="doc-missing-info">
                            <div class="doc-info">
                                <strong>Certificato/i di agibilità INPS</strong>
                                <span class="doc-meta" [class.crit]="agibilita_inps.length <= 0">{{ agibilita_inps.length <= 0 ? 'non caricato' : 'aggiungi altri file' }}</span>
                            </div>
                        </div>
                        <app-file-upload [form]="formEvento" [control]="'agibilita_inps_file'" [label]="''" [multiple]="true" [critical]="agibilita_inps.length <= 0" [accept]="'.doc,.docx,application/pdf,image/*'" [text]="'Trascina qui il file'"></app-file-upload>
                    </div>
                </div>

                <span class="sec-subtitle">Montaggio</span>
                <div class="flag-row">
                    <p-checkbox inputId="montaggio" name="montaggio" formControlName="montaggio" value="montaggio" (onChange)="onCertificazioneImpianti($event)" />
                    <label for="montaggio">Corretto montaggio</label>
                </div>
                <div class="doc-list">
                    @for (file of montaggio; track file.id) {
                        <app-file-loaded [evento]="evento" [documento]="file" [tipo]="'montaggio'" [file]="file.file || ''" [title]="'Documento di montaggio'" [meta]="'caricato · clicca Apri per scaricare'" [status]="'caricato'" [tooltip]="'Rimuovi documento di montaggio'"></app-file-loaded>
                    }
                    <div class="doc-missing" [class.crit]="montaggio.length <= 0">
                        <div class="doc-missing-info">
                            <div class="doc-info">
                                <strong>Documenti di montaggio</strong>
                                <span class="doc-meta" [class.crit]="montaggio.length <= 0">{{ montaggio.length <= 0 ? 'non caricato' : 'aggiungi altri file' }}</span>
                            </div>
                        </div>
                        <app-file-upload [form]="formEvento" [control]="'montaggio_file'" [label]="''" [multiple]="true" [critical]="montaggio.length <= 0" [accept]="'.doc,.docx,application/pdf,image/*'" [text]="'Trascina qui il file'"></app-file-upload>
                    </div>
                </div>

                <span class="sec-subtitle">Certificazioni impianti</span>
                <div class="matrice">
                    <div class="matrice-titolo">Cosa porta la compagnia · Si apre il box certificati sotto</div>

                    <div class="matrice-row">
                        <div class="label-mat" [class.attivo]="hasImpianto('non_presenti')">
                            Impianti non presenti
                            <span class="sub">nessun impianto portato dalla compagnia</span>
                        </div>
                        <div class="matrice-toggle">
                            <button type="button" class="matrice-opt si" [class.active]="hasImpianto('non_presenti')" (click)="setImpianto('non_presenti', 'Si')">Si</button>
                            <button type="button" class="matrice-opt" [class.active]="!hasImpianto('non_presenti')" (click)="setImpianto('non_presenti', 'No')">No</button>
                        </div>
                    </div>

                    @for (item of impiantiOptions; track item.value) {
                        <div class="matrice-row" [class.disabled]="hasImpianto('non_presenti')">
                            <div class="label-mat" [class.attivo]="hasImpianto(item.value) && docsByTipo(item.value).length > 0" [class.crit]="hasImpianto(item.value) && docsByTipo(item.value).length === 0">
                                {{ item.label }}
                                @if (hasImpianto(item.value)) {
                                    <span class="sub" [class.crit]="docsByTipo(item.value).length === 0">{{ docsByTipo(item.value).length }} {{ docsByTipo(item.value).length === 1 ? 'documento caricato' : 'documenti caricati' }}</span>
                                }
                            </div>
                            <div class="matrice-toggle">
                                <button type="button" class="matrice-opt si" [class.active]="hasImpianto(item.value)" [disabled]="hasImpianto('non_presenti')" (click)="setImpianto(item.value, 'Si')">Si</button>
                                <button type="button" class="matrice-opt" [class.active]="!hasImpianto(item.value)" [disabled]="hasImpianto('non_presenti')" (click)="setImpianto(item.value, 'No')">No</button>
                            </div>
                        </div>
                    }

                    <div class="matrice-row" [class.disabled]="hasImpianto('non_presenti')">
                        <div class="label-mat" [class.attivo]="hasImpianto('altro') && docsByTipo('altro').length > 0" [class.crit]="hasImpianto('altro') && docsByTipo('altro').length === 0">
                            Altro
                            @if (hasImpianto('altro')) {
                                <span class="sub" [class.crit]="docsByTipo('altro').length === 0">{{ docsByTipo('altro').length }} {{ docsByTipo('altro').length === 1 ? 'documento caricato' : 'documenti caricati' }}</span>
                            } @else {
                                <span class="sub">certificazione non in elenco</span>
                            }
                        </div>
                        <div class="matrice-toggle">
                            <button type="button" class="matrice-opt si" [class.active]="hasImpianto('altro')" [disabled]="hasImpianto('non_presenti')" (click)="setImpianto('altro', 'Si')">Si</button>
                            <button type="button" class="matrice-opt" [class.active]="!hasImpianto('altro')" [disabled]="hasImpianto('non_presenti')" (click)="setImpianto('altro', 'No')">No</button>
                        </div>
                    </div>
                </div>

                @if (!hasImpianto('non_presenti')) {
                    @for (item of impiantiOptions; track item.value) {
                        @if (hasImpianto(item.value)) {
                            <div class="impianto-block">
                                <div class="impianto-block-head">
                                    <h4>{{ item.label }} · certificati richiesti</h4>
                                    <span class="req">{{ docsByTipo(item.value).length > 0 ? docsByTipo(item.value).length + ' documenti' : 'documento richiesto' }}</span>
                                </div>
                                <div class="doc-list">
                                    @for (doc of docsByTipo(item.value); track doc.id) {
                                        <app-file-loaded [evento]="evento" [documento]="doc" [tipo]="item.value" [file]="doc.file || ''" [title]="'Documenti ' + item.label" [meta]="'caricato · clicca Apri per scaricare'" [status]="'caricato'" [tooltip]="'Rimuovi documento'"></app-file-loaded>
                                    }
                                    <div class="doc-missing" [class.crit]="docsByTipo(item.value).length <= 0">
                                        <div class="doc-missing-info">
                                            <div class="doc-info">
                                                <strong>Documenti {{ item.label }}</strong>
                                                <span class="doc-meta" [class.crit]="docsByTipo(item.value).length <= 0">{{ docsByTipo(item.value).length <= 0 ? 'non caricato' : 'aggiungi altri file' }}</span>
                                            </div>
                                        </div>
                                        <app-file-upload [form]="formEvento" [control]="item.control" [label]="''" [multiple]="true" [critical]="docsByTipo(item.value).length <= 0" [accept]="'.doc,.docx,application/pdf,image/*'" [text]="'Trascina qui il file'"></app-file-upload>
                                    </div>
                                </div>
                            </div>
                        }
                    }

                    @if (hasImpianto('altro')) {
                        <div class="impianto-block">
                            <div class="impianto-block-head">
                                <h4>Altro · certificati richiesti</h4>
                                <span class="req">{{ docsByTipo('altro').length > 0 ? docsByTipo('altro').length + ' documenti' : 'documento richiesto' }}</span>
                            </div>
                            <div class="fld">
                                <label>* Descrizione certificazione/i</label>
                                <input type="text" pInputText formControlName="certificazione_impianti_extra" required />
                                @if (formEvento.get('certificazione_impianti_extra')?.hasError('required') && (formEvento.get('certificazione_impianti_extra')?.dirty || formEvento.get('certificazione_impianti_extra')?.touched)) {
                                    <small class="text-red-600 block font-medium">La certificazione dell'impianto è obbligatoria!</small>
                                }
                            </div>
                            <div class="doc-list">
                                @for (doc of docsByTipo('altro'); track doc.id) {
                                    <app-file-loaded [evento]="evento" [documento]="doc" [tipo]="'altro'" [file]="doc.file || ''" [title]="'Certificazione impianti — Altro'" [meta]="'caricato · clicca Apri per scaricare'" [status]="'caricato'" [tooltip]="'Rimuovi documento'"></app-file-loaded>
                                }
                                <div class="doc-missing" [class.crit]="docsByTipo('altro').length <= 0">
                                    <div class="doc-missing-info">
                                        <div class="doc-info">
                                            <strong>Documenti certificazione — Altro</strong>
                                            <span class="doc-meta" [class.crit]="docsByTipo('altro').length <= 0">{{ docsByTipo('altro').length <= 0 ? 'non caricato' : 'aggiungi altri file' }}</span>
                                        </div>
                                    </div>
                                    <app-file-upload [form]="formEvento" [control]="'certificazione_impianti_extra_file'" [label]="''" [multiple]="true" [critical]="docsByTipo('altro').length <= 0" [accept]="'.doc,.docx,application/pdf,image/*'" [text]="'Trascina qui il file'"></app-file-upload>
                                </div>
                            </div>
                        </div>
                    }
                }

                @if (formEvento.get('certificazione_impianti')?.hasError('required') && (formEvento.get('certificazione_impianti')?.dirty || formEvento.get('certificazione_impianti')?.touched)) {
                    <small class="text-red-600 block font-medium">La certificazione degli impianti è obbligatoria!</small>
                }

                <app-documenti-accrediti-backoffice [documenti]="documenti || []" [evento]="evento" />
            </div>
        </section>

        <!-- §6 MEZZI -->
        <section class="sec mezzi" [class.collapsed]="!openSections['mezzi']">
            <div class="sec-head" (click)="toggleSec('mezzi')">
                <h3>Mezzi di trasporto</h3>
                <span class="stato-mini" [ngClass]="(evento?.mezzi || []).length ? 'ok' : 'ok'">
                    {{ (evento?.mezzi || []).length + ((evento?.mezzi || []).length > 1 ? ' mezzi' : ' mezzo') || 'nessuno' }}
                </span>
                <span class="toggle">▾</span>
            </div>
            <div class="sec-body">
                <app-mezzi-trasporto-accrediti-backoffice [mezzi]="evento?.mezzi || []" [evento]="evento" />
            </div>
        </section>

        <div class="scheda-actions">
            <div>
                <button class="acc-btn acc-btn-primary" type="submit">Modifica</button>
            </div>
            <div>
                <p-confirmPopup #delete>
                    <ng-template pTemplate="headless" let-message>
                        <div class="border-round p-3">
                            <span class="text-base">{{ message.message }}</span>
                            <div class="acc-actions" style="margin-top: 12px;">
                                <button type="button" class="acc-btn acc-btn-danger flex-1" (click)="onDelete()">Elimina</button>
                                <button type="button" class="acc-btn acc-btn-ghost flex-1" (click)="onAnnulla()">Annulla</button>
                            </div>
                        </div>
                    </ng-template>
                </p-confirmPopup>
                <button class="acc-btn acc-btn-danger" type="button" (click)="onDeletePopup($event)">Elimina</button>
            </div>
        </div>
    </form>
</section>
